import React, { Fragment } from "react";
import cn from "classnames";
import "./style.css";

const split = words => words.split(" ");

const Heading = ({ headings = ["test test", "test test test", "blah"] }) => (
  <h1 id="heading" className="heading">
    {headings.map(({ text, highlight = [] }, i) => (
      <span id={`heading-${i}`} className="heading__words">
        {split(text).map((word, i) => (
          <Fragment>
            <span
              className={cn("heading__word", {
                "heading__word--highlight": highlight.includes(i),
              })}
            >
              {word}
            </span>
            {i !== split(text).length - 1 ? " " : ""}
          </Fragment>
        ))}
      </span>
    ))}
  </h1>
);

export default Heading;



// WEBPACK FOOTER //
// ./src/components/heading/index.js